import React, { useState, useRef, useEffect } from 'react';
import { Overlay } from 'react-bootstrap';
import CreateTagModal from './CreateTagModal';
import TagService from '../Services/TagService';
import PubSub from 'pubsub-js';

function InboxTagsButton({ thread_id, existing_tags = [], onRefresh }) {

    const [show, setShow] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const target = useRef(null);
    const [selectedLabels, setSelectedLabels] = useState([]);
    const [newLabel, setNewLabel] = useState('');
    const [tags, setTags] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');


    useEffect(() => {
        getAllTags();
    }, []);

    useEffect(() => {
        if (Array.isArray(existing_tags) && existing_tags.length > 0) {
            setSelectedLabels(existing_tags);
        }
    }, [existing_tags]);


    function toggleLabel(label) {
        setSelectedLabels(prev =>
            prev.includes(label)
                ? prev.filter(l => l !== label)
                : [...prev, label]
        );
    }

    function onClickRemoveLabel(e, tag_id, label) {
        e.preventDefault();
        setSelectedLabels(prev => prev.filter(l => l !== label));

        // Remover el tag solo de este thread específico
        TagService.removeTagsFromGmailThread({
            thread_id,
            tags: [label]
        }).then(() => {
            PubSub.publish('show-basic-notification', {
                title: 'Success',
                message: `Label ${label} removed from this thread`
            });
            onRefresh(); // Refrescar para mostrar los cambios
        });
    }

    const handleNewLabelChange = (e) => {
        setNewLabel(e.target.value);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    async function getAllTags() {
        let data = await TagService.getAllTags();
        setTags(data);
    }

    async function handleCreateNewLabel(labelName, color) {
        let { message } = await TagService.createTag({ name: labelName, color });

        PubSub.publish('show-basic-notification', {
            title: 'Success',
            message: message
        });

        getAllTags();
        setModalShow(false);

    };

    async function onApplyTags() {

        const tagsToRemove = existing_tags.filter(tag => !selectedLabels.includes(tag));
        if (tagsToRemove.length > 0) {
            await TagService.removeTagsFromGmailThread({
                thread_id,
                tags: tagsToRemove
            });
        }

        let { message } = await TagService.addTagsToGmailThread({
            thread_id, // Cambia esto por el ID real del hilo
            tags: selectedLabels
        });

        PubSub.publish('show-basic-notification', {
            title: 'Success',
            message: message
        });

        setShow(false);
        onRefresh();

    }

    // Filtrar tags según el query de búsqueda
    const filteredTags = tags.filter(tag =>
        tag.name.toLowerCase().includes(searchQuery.toLowerCase())
    );


    function renderLocalLabels() {

        return existing_tags.map((tag, index) => {
            let color = tags.find(t => t.name === tag)?.color || '#e0e0e0';
            return (
                <span key={index} className="badge badge-inbox me-2 position-relative"
                    style={{
                        backgroundColor: color,
                        paddingRight: '20px',
                        cursor: 'pointer'
                    }}>
                    {tag}
                    <i
                        className="fa-solid fa-times position-absolute"
                        style={{
                            right: '6px',
                            top: '52%',
                            transform: 'translateY(-50%)',
                            fontSize: '10px',
                            cursor: 'pointer',
                            opacity: '0.8'
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            onClickRemoveLabel(e, tags.find(t => t.name === tag)?._id, tag);
                        }}
                        title="Remove label"
                    ></i>
                </span>
            )
        });
    }


    return (
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
            <button
                ref={target}
                onClick={() => setShow(!show)}
                className="inbox-button"
                data-tooltip-id="inbox-tooltip"
                data-tooltip-content="Labels"
            >
                <i className="fa-solid fa-tags"></i>
            </button>

            <Overlay
                target={target.current}
                show={show}
                placement="bottom-start"
                rootClose
                onHide={() => setShow(false)}
            >
                {({ placement, arrowProps, show: _show, popper, ...props }) => (
                    <div
                        {...props}
                        style={{
                            zIndex: 1000,
                            backgroundColor: 'white',
                            padding: '1rem',
                            borderRadius: '8px',
                            border: '1px solid #ccc',
                            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
                            minWidth: '220px',
                            ...props.style,
                        }}
                    >
                        <div className="fw-bold mb-2">Labels</div>
                        <div className="d-flex flex-column gap-2">

                            {/* Buscador */}
                            <input
                                type="text"
                                placeholder="Search labels..."
                                value={searchQuery}
                                className='mb-2'
                                onChange={handleSearchChange}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: 'none',  // Eliminar los bordes laterales y superior
                                    borderBottom: '2px solid #ccc',  // Solo borde inferior
                                    outline: 'none',
                                    fontSize: '14px',
                                    color: '#202124',
                                    boxSizing: 'border-box',
                                    transition: 'border-color 0.3s, box-shadow 0.3s, background-color 0.3s',
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#4285f4';  // Color azul de Google
                                    e.target.style.backgroundColor = '#ffffff';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#ccc';  // Color gris claro
                                    e.target.style.backgroundColor = '#ffffff';
                                }}
                            />

                            {filteredTags.map(({ _id, name, color }, index) => (
                                <label key={index} className="d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        className="me-2"
                                        style={{ transform: 'scale(1.3)' }}
                                        checked={selectedLabels.includes(name)}
                                        onChange={() => toggleLabel(name)}
                                    />
                                    <span
                                        style={{
                                            backgroundColor: color || '#e0e0e0',
                                            color: 'white',
                                            borderRadius: '12px',
                                            padding: '4px 12px',
                                            fontSize: '12px',
                                            fontWeight: '500',
                                            display: 'inline-block',
                                        }}
                                    >
                                        {name}
                                    </span>

                                    <i
                                        className="fa-solid fa-trash ms-auto text-muted"
                                        style={{ cursor: 'pointer' }}
                                        onClick={(e) => onClickRemoveLabel(e, _id, name)}
                                    ></i>

                                </label>
                            ))}
                        </div>

                        <hr className="my-3" />

                        {(selectedLabels.length > 0 || existing_tags?.length > 0) && (
                            <button
                                className="btn btn-sm btn-outline-primary w-100"
                                onClick={() => onApplyTags()}
                            >
                                Apply
                            </button>
                        )}

                        <button
                            className="btn btn-sm btn-outline-primary w-100 mt-2"
                            onClick={() => setModalShow(true)}
                        >
                            + Create new
                        </button>


                    </div>
                )}
            </Overlay>
            <CreateTagModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                newLabel={newLabel}
                onLabelChange={handleNewLabelChange}
                onCreate={handleCreateNewLabel}
            />


            {renderLocalLabels()}


        </div>
    )
}


export default InboxTagsButton;